/**
 * Removes all nullish fields (`null` and `undefined`) from the `obj` recursively and returns result as a new object.
 *
 * Empty arrays and empty objects counts as nullish and are gonna be removed also.
 *
 * Test
 * ```
 * 	var test = { a: 1, b: undefined, c: { d : 1, e: null }, f: {}, g: [], h: { i: 1, j: [1, 2], k: [] }, l: { m: 0, n: ''}  };
 * 	console.log(removeEmpty(test));
 * ```
 * @param obj
 * @returns
 */
export function removeEmptyValues(obj) {
    const clean = Object.fromEntries(Object.entries(obj)
        // Important! map must be executed before filter, or it won't work correctly.
        .map(([k, v]) => [k, v === Object(v) ? removeEmptyValues(v) : v])
        .filter(([_, v]) => v != null && (v !== Object(v) || Object.keys(v).length)));
    return Array.isArray(obj) ? Object.values(clean) : clean;
}
